<div class="question-type-survey-short-answer-wrapper">
  <div class="form-group">
    <p [innerHtml]="sanitizer.bypassSecurityTrustHtml(descriptiveQuestion)"></p>
    <textarea class="form-control" rows="4" placeholder="{{'items.placeholderAns' | translate}}" 
    readonly></textarea>
  </div>
</div>
